
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/upgrade",
      function () {
        return require("private-next-pages/shopping/upgrade.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shopping/upgrade"])
      });
    }
  